import { User } from "projects/sepidz-web-framework/src/lib/models";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class ExternalNotification extends EntityBase {
  public Kind: number;

  public KindTitle: string;

  public ReferenceId?: number;

  public Title: string;

  public Description: string;

  public ImportanceLevel: number;

  public NotificationState: number;

  public NotificationStateTitle: string;

  public SeenTime?: Date;

  public SeenByUserId?: number;

  public SeenByUser?: User;
}

export enum ExternalNotificationKindEnum {
  Sepidz = 1,
  Fleet = 2,
  Delino = 3,
}

export enum ExternalNotificationStateKindEnum {
  Seen = 1,

  DontSeen = 2,
}
